import { useNavigate, Navigate } from 'react-router-dom'
import { Container } from '../../components/layout/Container'
import { Card } from '../../components/ui/Card'
import { Button } from '../../components/ui/Button'
import { useAuth } from '../../hooks/useAuth'

export function WorkspaceSelectorPage() {
  const { tenants, selectTenant } = useAuth()
  const navigate = useNavigate()

  // Si solo hay un tenant, saltar la selección y entrar directamente
  if (tenants.length === 1) {
    selectTenant(tenants[0].id)
    return <Navigate to="/app/ingest" replace />
  }

  const handleSelect = (tenantId: string) => {
    selectTenant(tenantId)
    navigate('/app')
  }

  return (
    <div className="flex min-h-screen items-center justify-center bg-bg">
      <Container size="narrow" className="py-20 text-center">
        <h1 className="text-3xl font-semibold tracking-tight text-text-primary">
          Selecciona tu workspace
        </h1>
        <p className="mt-4 text-text-secondary">
          Elige el espacio de trabajo al que quieres acceder.
        </p>

        <div className="mt-10 grid gap-4">
          {tenants.map((tenant) => (
            <Card key={tenant.id} variant="elevated" hover className="text-left">
              <div className="flex items-center justify-between">
                <div>
                  <p className="text-lg font-medium text-text-primary">{tenant.name}</p>
                  <p className="text-sm text-text-muted">{tenant.slug}</p>
                </div>
                <Button onClick={() => handleSelect(tenant.id)}>Entrar</Button>
              </div>
            </Card>
          ))}
        </div>
      </Container>
    </div>
  )
}
